import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import TopFavoriteBannerStyles from './TopFavoriteBanner.styled';
import TopFavorite from './images/TopFavorite.svg';
import { DXAccountContext } from '@contexts/DXAccountContext';
import CheckmarkSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/checkmark.svg';

const TopFavoriteBanner = ({ modelNumber }) => {
  const accountContext = useContext(DXAccountContext);
  const [removed, setRemoved] = useState(false);
  const [topFavorite, setTopFavorite] = useState(false);

  useEffect(() => {
    accountContext?.state?.account?.profile?.topFavoriteHome
      ? setTopFavorite(
          JSON.parse(accountContext.state?.account?.profile?.topFavoriteHome)
            ?.modelNumber === modelNumber
        )
      : setTopFavorite(false);
  }, [accountContext?.state?.account?.profile?.topFavoriteHome, modelNumber]);

  const removeTopFavoriteHome = () => {
    setRemoved(true);

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const { likedFeatures, ...newProfile } = accountContext.state.account
      ?.profile || {
      likedFeatures: [],
      profileId: 0,
      profileType: 'corp',
    };

    accountContext.actions.updateProfile({
      ...newProfile,
      topFavoriteHome: null,
    });
  };

  return topFavorite || removed ? (
    <TopFavoriteBannerStyles>
      {!removed ? (
        <div className="top-favorite-home">
          <TopFavorite />
          <div className="top-favorite-text">
            <h5>Your Top Favorite Home</h5>
            <p
              className="remove label large"
              onClick={() => removeTopFavoriteHome()}
            >
              Remove
            </p>
          </div>
        </div>
      ) : (
        <div className="top-favorite-removed">
          <CheckmarkSvg viewBox="0 0 16 16" />
          <p className="label large">Removed as Top Favorite Home</p>
        </div>
      )}
    </TopFavoriteBannerStyles>
  ) : null;
};

TopFavoriteBanner.propTypes = {
  modelNumber: PropTypes.any,
};

export default TopFavoriteBanner;
